// frontend/src/Components/UI/FieldError/FieldError.js
// Animated field-level error message displayed directly under a form field.
//
// Usage:
//   <FieldError message={fieldErrors.email} fieldId="email" />
//
// Props:
//   message  — the error string (renders nothing when falsy)
//   fieldId  — name/id of the associated input (used for scroll-target & aria)
//   className — optional extra CSS class

import React from 'react';
import './FieldError.css';

const FieldError = ({ message, fieldId, className = '' }) => {
  if (!message) return null;

  return (
    <span
      className={`field-error${className ? ` ${className}` : ''}`}
      role="alert"
      aria-live="polite"
      id={fieldId ? `${fieldId}-error` : undefined}
      // Marker picked up by useFieldErrors.scrollToFirstError()
      data-field-id={fieldId}
    >
      {/* Minimal inline warning circle */}
      <svg
        className="field-error__icon"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        aria-hidden="true"
        focusable="false"
      >
        <circle cx="6" cy="6" r="5.5" stroke="currentColor" strokeWidth="1.2" />
        <line x1="6" y1="3.5" x2="6" y2="6.8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <circle cx="6" cy="8.6" r="0.7" fill="currentColor" />
      </svg>
      {message}
    </span>
  );
};

export default FieldError;
